import { css } from '@emotion/react';

export default (theme) => css`
  .content {
    padding-bottom: 24px;
    margin: auto;
    max-width: 380px;
    padding-top: 48px;
    @media ${theme.media.atLeastTablet} {
      max-width: none;
      padding-top: 0;
      text-align: center;
    }
  }
  .sorry {
    color: ${theme.color.gray2};
    font-size: 124px;
    text-transform: uppercase;
    @media ${theme.media.atLeastTablet} {
      font-size: 80px;
    }
  }
  .text {
    font-size: 16px;
  }
  img {
    max-width: 100%;
  }
  .signup-survey {
    display: block;
    padding-top: 16px;
    color: ${theme.color.text};
    cursor: pointer;
    text-decoration: underline;
    font-size: 16px;
  }
`;
